import { render, staticRenderFns } from "./OtherJobPage.vue?vue&type=template&id=5cba5663"
import script from "./OtherJobPage.vue?vue&type=script&lang=js"
export * from "./OtherJobPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports